<script setup>

import {__, _mareike_nonce, notify} from "../../../assets/javascripts/library";
import FullScreenModal from "../../../assets/components/FullScreenModal.vue";
import {ref} from "vue";
import Modal from "../../../assets/components/Modal.vue";
import { useAjax } from "../../../assets/javascripts/useAjax.js";
import ShowInvoicePartial from "./Partials/ShowInvoice.vue";
import EditInvoicePartial from "./Partials/EditInvoice.vue";
import Header from "./Partials/HeaderMyInvoice.vue";

const props = defineProps({
  data: {
    type: Object,
    default: () => ({})
  }, showInvoice: Boolean
})
const showInvoice = ref(props.showInvoice)
const emit = defineEmits(["close"])
const denyInvoiceDialog = ref(false)
const { data, loading, error, request } = useAjax()
const modeShow = ref(true)
const costunits = ref(null)
const newInvoice = ref(null)

async function rejectInvoice() {
  const data = await request("/wp-json/mareike/invoices/reject", {
    method: "POST",
    body: {
      mareike_nonce: _mareike_nonce(),
      invoice_id: props.data.id
    }
  });

  if (data.status === 'success') {

    notify(__('Invoice accepted', 'mareike'), 'success');
  } else {
    notify(__('An error occurred accepting the invoice.', 'mareike'), 'error');
  }
  close();
}


function close() {
  emit('close')
}
</script>

<template>

  <FullScreenModal
      :show="showInvoice"
      :title="__('Please enter your data', 'mareike')"
      @close="emit('close')"
  >

  <Header :data="props.data" @reject="rejectInvoice" />
  <ShowInvoicePartial
      :data="props.data"
      @reject="rejectInvoice"
      @deny="openDenyInvoiceDialog"
      @fix="openInvoiceFixDialog"
  />

  </FullScreenModal>
</template>

<style>
.mareike-deny-invoice-button {
  width: 150px !important;
  margin-top: 10px;
}

 #invoice_details_header{
   font-weight: bold;
   font-size: 12pt;
   line-height: 1.8em;
   width: 100%;

 }
 #invoice_details_header table {
   border-style: solid;
   border-width: 1px;
   border-radius: 10px !important;
   width: 98%;
   border-color: #c0c0c0;
   box-shadow: 5px 5px 10px #c0c0c0;
   margin-bottom: 75px;
   font-weight: normal;
 }
 #invoice_details_header table tr td:first-child {
   padding-right: 50px;
   width: 175px;
 }

 #invoice_details_header table tr td:nth-child(2) {
   padding-right: 25px;
 }

 #invoice_details_header table tr td:nth-child(3) {
   padding-right: 50px;
   width: 100px;
   vertical-align: top;
 }

 #invoice_details_body {
   height: 400px;
   overflow: auto;

 }


 #invoice_details_body table tr:nth-child(1) td,
 #invoice_details_body table tr:nth-child(2) td,
 #invoice_details_body table tr:nth-child(3) td,
 #invoice_details_body table tr:nth-child(4) td,
 #invoice_details_body table tr:nth-child(6) td{
   vertical-align: top;
   height: 20px;
 }

 #invoice_details_body table tr:nth-child(5) td {
   height: 50px;
 }


 #invoice_details_body table {
   width: 100%;

 }

 #invoice_details_body table tr:nth-child(1) td:first-child {
   padding-right: 50px;

 }

 #invoice_details_body table tr:nth-child(1) td:nth-child(2),
 #invoice_details_body table tr:nth-child(1) td:nth-child(3)
 {
   width: 250px;

 }

 .mareike-accept-button {
   background-color: #36c054 !important;
   color: #ffffff !important;
 }

 .mareike-deny-button {
   background-color: #ee4b5c !important;
   color: #ffffff !important;
 }

 .mareike-fix-button {
   background-color: #d3d669 !important;
   color: #67683c !important;
 }

 .mareike-button {
   padding: 5px 25px !important;
   font-size: 11pt !important;
   margin-bottom: 10px;
   width: 100%;
   padding-right: 2px;
 }


</style>